module.exports = __webpack_public_path__ + "static/media/kinkhao_03_full.499c0f96.png";